export const UMB_PROPERTY_HAS_VALUE_CONDITION_ALIAS = 'Umb.Condition.Property.HasValue';
